import { useState, useCallback } from "react"

/**
 * Boolean hook helper
 *
 * @param initialValue boolean
 * @returns [value, setToTrue, setToFalse, toggle, setValue]
 */
export function useBoolean(
    initialValue: boolean
): [boolean, () => void, () => void, () => void, (value: boolean) => void] {
    const [value, setValue] = useState(initialValue)
    const setToTrue = useCallback(() => setValue(true), [setValue])
    const setToFalse = useCallback(() => setValue(false), [setValue])
    const toggle = useCallback(
        () => setValue(prevValue => !prevValue),
        [setValue]
    )

    return [value, setToTrue, setToFalse, toggle, setValue]
}
